import LocalizedStrings from 'react-localization';
import en from './en.json';
import he from './he.json';

export default new LocalizedStrings({ en, he });



// WEBPACK FOOTER //
// ./src/lib/strings/index.js